export default "__VITE_ASSET__CyQ6EMNJ__"